// extracted by mini-css-extract-plugin
export default {"root":"LoginPopup_root__CTqcn"};